module.exports = __webpack_public_path__ + "static/shattered-dark-79d447e75159485f633bde76ec1240b9.png";